import React, { useEffect, useState } from 'react';

import { Country, State } from 'country-state-city';

import { FilterDropdown } from '.';

export const CountryFilter = ({ selected = [], onChange }) => {
    const countries = Country.getAllCountries();

    const options = countries.map(c => ({
        name: c.name,
        value: c.isoCode,
    }));

    return (
        <FilterDropdown
            label='Country'
            options={options}
            selected={selected}
            setSelected={onChange}
            tooltip=''
            list_search={true}
            isMulti={true}
        />
    );
};

export const StateFilter = ({ countryCodes = [], selected = [], onChange, options: externalOptions }) => {
    const [options, setOptions] = useState([]);

    useEffect(() => {
        if (externalOptions?.length) {
            setOptions(externalOptions);
            return;
        }

        if (!countryCodes.length) return;

        const stateOptions = [];
        countryCodes.forEach(code => {
            const states = State.getStatesOfCountry(code);
            stateOptions.push(
                ...states.map(s => ({
                    id: `${code}-${s.isoCode}`,
                    name: s.name,
                }))
            );
        });

        setOptions(stateOptions);
    }, [countryCodes, externalOptions]);

    return (
        <FilterDropdown
            label='State'
            options={options}
            selected={selected}
            setSelected={onChange}
            isMulti={true}
            showActive={true}
        />
    );
};

export const CityFilter = ({ countryCode, stateCodes = [], selected = [], onChange, options, geoData }) => {
    const [cityOptions, setCityOptions] = useState(options || []);

    useEffect(() => {
        if (!countryCode || !stateCodes.length) return;

        const cities = [];

        stateCodes.forEach(stateCode => {
            const cityList = geoData.citiesByState[stateCode] || [];
            cities.push(
                ...cityList.map(city => ({
                    id: city.id,
                    name: city.name,
                }))
            );
        });

        setCityOptions(cities);
    }, [countryCode, stateCodes]);

    return (
        <FilterDropdown
            label='City'
            options={cityOptions}
            selected={selected}
            setSelected={onChange}
            isMulti={true}
            showActive={true}
        />
    );
};
